export const BdIoIds = {
    baseProfileInputId: "BaseProfile",
    quiltOutputId: "QuiltOutput",
    baseFabricInputId: "BaseFabric",
    quiltPatternInputId: "QuiltPattern",
    quiltStrengthInputId: "QuiltStrength",
    quiltWidthInputId: "QuiltWidth",
    quiltHeightInputId: "QuiltHeight",
    quiltedFabricFabricHOffsetInputId: "FabricHorizontalOffset",
    quiltedFabricFabricVOffsetInputId: "FabricVerticalOffset",
    quiltedFabricFabricRotationInputId: "FabricRotation",
    quiltedFabricQuiltHOffsetInputId: "QuiltHorizontalOffset",
    quiltedFabricQuiltVOffsetInputId: "QuiltVerticalOffset",
    pullerPositionOnCurveInputId: "PullerPositioning/PullerPositionOnCurve",
}
